import { render, staticRenderFns } from "./PensionPdfContent.vue?vue&type=template&id=11b5d2c2&scoped=true"
import script from "./PensionPdfContent.vue?vue&type=script&lang=js"
export * from "./PensionPdfContent.vue?vue&type=script&lang=js"
import style0 from "./PensionPdfContent.vue?vue&type=style&index=0&id=11b5d2c2&prod&lang=scss&scoped=true"
import style1 from "./PensionPdfContent.vue?vue&type=style&index=1&id=11b5d2c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b5d2c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
